import "@/assets/vendor/nucleo/css/nucleo.css"
import "@/assets/scss/argon.scss"
import globalComponents from "./globalComponents"
import globalDirectives from "./globalDirectives"
import SidebarPlugin from "@/components/SidebarPlugin/index"
import NotificationPlugin from "@/components/NotificationPlugin/index"
import { createBootstrap } from "bootstrap-vue-next/plugins/createBootstrap"

export default {
  install(app) {
    app.use(globalComponents)
    app.use(globalDirectives)
    app.use(SidebarPlugin)
    app.use(NotificationPlugin)
    app.use(createBootstrap())
  },
}
